export default {
  current(state) {
    return state.current;
  },
  forecast(state) {
    return state.forecast;
  },
};
